import React from "react";
import { cn } from "./cn";
import { AlertIcon } from "../../../assets/ui/icons";

/* Form-level error notice. Distinct from a field error: this is for what the submit came back with — wrong password, unknown user, a server failure — which... */
export const ErrorNote = ({ children, className = "" }) => (
  <div
    role="alert"
    className={cn(
      "mt-3.5 flex items-start gap-2 rounded-lg px-3 py-2.5",
      "bg-[var(--coral)]/[0.08] border border-[var(--coral)]/25",
      "text-[12.5px] leading-[1.45] text-[var(--coral-deep)] font-sans text-left",
      className
    )}
  >
    <AlertIcon />
    <span>{children}</span>
  </div>
);

export default ErrorNote;
